/* eslint-disable max-len */
import { Row, Divider } from 'antd'
import React, { useState } from 'react'
import { Project } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { currencyListSelector } from 'src/features'
import { CustomText, CustomCol } from 'src/components'
import styles from './ProjectPriceDetailCard.module.scss'
import { getContributionUnitInUserLanguage } from 'src/core/json'
import { getFormatedPrice, getProjectUnit, getVintageAvailableStock } from 'src/core/helpers'
import ProjectTransferModal from './ProjectTransferModal/ProjectTransferModal'
import ProjectPriceDetailButtonsContent from './ProjectPriceDetailButtonsContent/ProjectPriceDetailButtonsContent'

interface ProjectPriceDetailCardProps {
  project: Project
  isModalPreview: boolean
}

const ProjectPriceDetailCard: React.FC<ProjectPriceDetailCardProps> = (props) => {
  const { project, isModalPreview } = props
  const { t, i18n: { language } } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)

  /* Project Currency Code */
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = currencyList?.find(c => c.id === project.currency_token)?.code

  /* Price and Stock */
  const projectPrice = getFormatedPrice(project.price, currencyCode)
  const vintageStock = getVintageAvailableStock(project) || project.get_vintage_items_available_sum_stock
  const stock_available = project.is_vintage ? vintageStock : project.available_volume_credits

  /* Custom Row Item */
  const rowItem = (label1: string, label2: string, isStrong2: boolean) => (
    <Row className={styles.priceContent}>
      <CustomCol lg={11} xs={11}>
        <CustomText label={label1} strong/>
      </CustomCol>
      <CustomCol lg={13} className={styles.priceUnitContent} xs={13}>
        <CustomText label={label2} strong={isStrong2} />
      </CustomCol>
    </Row>
  )

  return (
    <div className={styles.card}>
      <Row>
        <CustomCol lg={9}>
          {!project.is_free_donation ? <>
            {/* Price Section */}
            {rowItem(t('Projects.Pricing'), `${projectPrice} / ${getProjectUnit(project.kind)}`, true)}

            {/* Biodiversity Label */}
            {project.kind === 'biodiversity' && (
              <CustomText
                label={t('Projects.CreditSubLabel')}
                type='secondary'
                className={styles.contributionUnit}
              />
            )}
            {/* Contribution Unit */}
            {project.is_contribution_kind && project.contribution_unit && (
              <div className={styles.contributionUnit}>
                <CustomText
                  label={getContributionUnitInUserLanguage(project.contribution_unit, language)}
                  type='secondary'
                />
              </div>
            )}
          </> : rowItem(t('Projects.Currency'), currencyCode, false)}

          <Divider className={styles.dividerMargin}/>

          {/* Stock Section */}
          <div className={styles.stockSection}>
            {/* Stock Available */}
            {rowItem(t('Projects.AvailableStock'), `${stock_available} ${getProjectUnit(project.kind)}`, false)}

            {/* Minimun Purchase */}
            {!isModalPreview && rowItem(
              t('Projects.MinPurchase'),
              `${project.kgco2_minimum_purchase / 1000} ${getProjectUnit(project.kind)}`,
              false
            )}

          </div>
        </CustomCol>

        {/* Buttons Section */}
        <CustomCol lg={15}>
          {!isModalPreview && <ProjectPriceDetailButtonsContent project={project}/>}
        </CustomCol>
      </Row>

      <ProjectTransferModal
        project={project}
        isModalVisible={isModalVisible}
        handleCancel={() => setIsModalVisible(false)}
      />
    </div>
  )
}

export default ProjectPriceDetailCard
